import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormControl,
  Flex,
  Menu,
  MenuList,
  MenuGroup,
  MenuItem,
  MenuButton,
  useDisclosure,
  Image,
  Input,
  Text,
  Spacer,
} from "@chakra-ui/react";
import React, { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  checkEmail,
  loginSuccess,
  logoutSuccess,
  signupSuccess,
} from "../Redux/auth/auth.actions";

const SignIn = () => {
  const msg = useSelector((state) => state.auth.successmsg);
  const token = useSelector((state) => state.auth.token);
  const loading = useSelector((state) => state.auth.loading);
  const user = JSON.parse(localStorage.getItem("user"));
  // const token = localStorage.getItem("token");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  // const [isAuth, setIsAuth] = useState(false);
  const [userType, setUserType] = useState("");
  // const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  function handleContinue(email) {
    dispatch(checkEmail(email)).then((res) => setUserType(res.data));
  }

  async function handleLogin(email, password) {
    dispatch(loginSuccess({ email, password })).then(() => {
      onClose();
    });
  }

  async function handleSignUp(name, email, password) {
    dispatch(signupSuccess({ name, email, password })).then(() => {
      dispatch(loginSuccess({ email, password }));
      onClose();
    });
  }

  async function handleLogout() {
    dispatch(logoutSuccess());
  }
  return (
    <Box>
      <Box>
        {!token ? (
          <Button colorScheme="red" onClick={onOpen}>
            LOGIN/SIGNUP
          </Button>
        ) : (
          <Flex gap={"10px"}>
            <Menu>
              <MenuButton as={Button} colorScheme="pink">
                {user?.user.name}
              </MenuButton>
              <MenuList>
                {/* <MenuGroup title="Profile"> */}
                <MenuItem>My Account</MenuItem>
                <MenuItem>
                  <Button onClick={() => alert("Hello")}>Logout</Button>
                </MenuItem>
                {/* </MenuGroup> */}
              </MenuList>
            </Menu>
            <Button onClick={handleLogout}>Logout</Button>
          </Flex>
        )}
      </Box>
      {!msg ? (
        <Modal onClose={onClose} size={"4xl"} isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent>
            <Flex>
              <Box width="55%">
                <Image src={"https://i.gifer.com/PSFA.gif"} />
              </Box>
              <Box>
                <ModalHeader>Enter your email to Signup or Login</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl>
                    <Input
                      type="email"
                      placeholder="Enter Your Email*"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  {loading ? (
                    <Button
                      isLoading
                      loadingText="Submitting"
                      colorScheme="teal"
                      variant="outline"
                    >
                      Continue
                    </Button>
                  ) : (
                    <Button onClick={() => handleContinue(email)}>
                      Continue
                    </Button>
                  )}
                </ModalFooter>
              </Box>
            </Flex>
          </ModalContent>
        </Modal>
      ) : msg === "registered" ? (
        <Modal onClose={onClose} size={"4xl"} isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent>
            <Flex>
              <Box width="55%">
                <Image src={"https://i.gifer.com/PSFA.gif"} />
              </Box>
              <Box width="45%">
                <ModalHeader>Please Login</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Input mb={4} value={email} disabled />
                  <FormControl>
                    <Input
                      placeholder="Enter The Password*"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </FormControl>
                  <Flex>
                    <Box color="tomato"></Box>
                    <Spacer />
                    <Box color="tomato">Change Email</Box>
                  </Flex>
                </ModalBody>
                <ModalFooter>
                  {loading ? (
                    <Button
                      isLoading
                      loadingText="Submitting"
                      colorScheme="teal"
                      variant="outline"
                    >
                      Login
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        handleLogin(email, password);
                      }}
                    >
                      Login
                    </Button>
                  )}
                </ModalFooter>
              </Box>
            </Flex>
          </ModalContent>
        </Modal>
      ) : (
        <Modal onClose={onClose} size={"4xl"} isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent>
            <Flex>
              <Box width="55%">
                <Image src={"https://i.gifer.com/PSFA.gif"} />
              </Box>
              <Box width="45%">
                <ModalHeader>Sign Up</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Input mb={4} value={email} disabled />
                  <FormControl>
                    <Input
                      mb={4}
                      placeholder="Enter Your Name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </FormControl>
                  <FormControl>
                    <Input
                      placeholder="Enter Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </FormControl>
                  <Flex>
                    <Box color="tomato"></Box>
                    <Spacer />
                    <Box color="tomato">Change Email</Box>
                  </Flex>
                </ModalBody>
                <ModalFooter>
                  {loading ? (
                    <Button
                      isLoading
                      loadingText="Submitting"
                      colorScheme="teal"
                      variant="outline"
                    >
                      Sign Up
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        handleSignUp(name, email, password);
                      }}
                    >
                      Sign Up
                    </Button>
                  )}
                </ModalFooter>
              </Box>
            </Flex>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default SignIn;
